/**
 * CRM pipeline stages for player (ProspectProfile) contacts.
 *
 * Values mirror the API's `PipelineStage` enum exactly — they are sent as-is in query
 * params and PATCH bodies. Labels are what the UI shows; keep the two in sync.
 */
export const PIPELINE_STAGES = [
  { value: "NewLead", label: "New Lead" },
  { value: "Contacted", label: "Contacted" },
  { value: "MeetingScheduled", label: "Meeting Scheduled" },
  { value: "ProposalSent", label: "Proposal Sent" },
  { value: "Signed", label: "Signed" },
  { value: "Inactive", label: "Inactive" },
  { value: "NoInterest", label: "No Interest" },
] as const;

export type PipelineStageValue = (typeof PIPELINE_STAGES)[number]["value"];

export const PIPELINE_STAGE_LABELS = PIPELINE_STAGES.map((s) => s.label);

/** Human label for a stage value; falls back to the raw value for anything unrecognized. */
export const pipelineStageLabel = (value: string | undefined | null): string => {
  if (!value) return "";
  return PIPELINE_STAGES.find((s) => s.value === value)?.label ?? value;
};

/** Inverse of {@link pipelineStageLabel}; returns undefined for unrecognized labels. */
export const pipelineStageValue = (label: string): PipelineStageValue | undefined =>
  PIPELINE_STAGES.find((s) => s.label === label)?.value;
